export default __webpack_public_path__ + "static/media/boy1.46a3f820.PNG";